import React, {useState, useEffect, useCallback} from 'react';
import {
    ProjectOutlined,
    RocketOutlined,
    RightOutlined,
    PlusOutlined,
    FolderOpenOutlined,
    GithubOutlined  // Добавьте этот импорт
} from '@ant-design/icons';
import styles from '@/styles/pages/MainPage.module.css';
import {useNavigate} from 'react-router-dom';
import {projectsAPI} from '@/api/endpoints/projects.js'

const MainPage = () => {
    const navigate = useNavigate();
    const [greeting, setGreeting] = useState('');
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = 'Личный портал | DevSpace';

        const hour = new Date().getHours();
        if (hour < 12) setGreeting('Доброе утро');
        else if (hour < 18) setGreeting('Добрый день');
        else setGreeting('Добрый вечер');
    }, []);

    const fetchProjects = useCallback(async () => {
        setLoading(true);
        const response = await projectsAPI.getAll(false);
        const projectsData = response.data || [];
        setProjects(projectsData);
        setLoading(false);
    }, [setProjects]);

    useEffect(() => {
        fetchProjects();
    }, [fetchProjects]);

    const handleCreateProject = () => {
        navigate('/projects/new');
    };

    const handleProjectClick = (projectId) => {
        navigate(`/projects/${projectId}`);
    };

    return (
        <div className={styles.portal}>
            {/* Фоновые декорации */}
            <div className={styles.bgGradient}></div>
            <div className={styles.bgGrid}></div>

            <div className={styles.container}>
                {/* Шапка */}
                <div className={styles.header}>
                    <div className={styles.userInfo}>
                        <div className={styles.avatar}>
                            <RocketOutlined/>
                        </div>
                        <div>
                            <h1 className={styles.greeting}>{greeting}!</h1>
                            <p className={styles.role}>Личный портал</p>
                        </div>
                    </div>

                    <div className={styles.headerActions}>
                        <div className={styles.statusBadge}>
                            <span className={styles.statusDot}></span>
                            Все системы работают
                        </div>
                        <button className={styles.newProjectBtn} onClick={handleCreateProject}>
                            <PlusOutlined/> Новый проект
                        </button>
                    </div>
                </div>

                {/* Секция проектов */}
                <div className={styles.projectsSection}>
                    <div className={styles.sectionHeader}>
                        <h2 className={styles.sectionTitle}>
                            <ProjectOutlined/> Мои проекты
                        </h2>
                        {projects.length > 0 && (
                            <a href="/projects" className={styles.viewAllLink}>
                                Все проекты <RightOutlined/>
                            </a>
                        )}
                    </div>

                    {loading ? (
                        <div className={styles.loadingState}>
                            <div className={styles.loadingSpinner}></div>
                            <p>Загрузка проектов...</p>
                        </div>
                    ) : (
                        projects.length > 0 ? (
                            <div className={styles.projectsList}>
                                {projects.map(project => (
                                    <div
                                        key={project.uuid}
                                        className={styles.projectCard}
                                        onClick={() => handleProjectClick(project.uuid)}
                                    >
                                        <div className={styles.projectIcon} style={{
                                            background: `var(--color-accent-primary)15`,
                                            color: `var(--color-accent-primary)`
                                        }}>
                                            <ProjectOutlined/>
                                        </div>
                                        <div className={styles.projectInfo}>
                                            <h3 className={styles.projectName}>{project.name}</h3>
                                            <div className={styles.projectMeta}>
                                                {project.repository_url && (
                                                    <a
                                                        href={project.repository_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={styles.projectRepo}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <GithubOutlined/> Репозиторий
                                                    </a>
                                                )}
                                                <span className={`${styles.projectStatus} ${styles[project.status]}`}>
            {project.status === 'active' ? 'Активен' :
                project.status === 'development' ? 'В разработке' :
                    project.status === 'staging' ? 'Тестирование' :
                        project.status === 'archived' ? 'Архивирован' :
                            project.status}
          </span>
                                            </div>
                                            {project.description && (
                                                <div className={styles.projectDescription}>
                                                    {project.description.length > 100
                                                        ? `${project.description.substring(0, 100)}...`
                                                        : project.description}
                                                </div>
                                            )}
                                        </div>
                                        <button
                                            className={styles.projectMenuBtn}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                // Здесь можно добавить меню проекта
                                            }}
                                        >
                                            ⋯
                                        </button>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={styles.emptyState}>
                                <div className={styles.emptyStateIcon}>
                                    <FolderOpenOutlined/>
                                </div>
                                <h3 className={styles.emptyStateTitle}>У вас пока нет проектов</h3>
                                <p className={styles.emptyStateDescription}>
                                    Создайте свой первый проект, чтобы начать работу
                                </p>
                                <button className={styles.createProjectButton} onClick={handleCreateProject}>
                                    <PlusOutlined/> Создать проект
                                </button>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default MainPage;